import { TextField } from '@flex-design-system/fx';
import {
  ChevronDownMiniIcon,
  PersonTextRectangleIcon,
} from '@flex-design-system/legacy-flex-icons';
import { Translation, useTranslation } from '@flex-packages/i18n';
import { trans } from '@flex-packages/i18n-base';
import { DISABLED_TYPE_CONTENT } from '@flex-private-packages/recruiting-common/base';
import { DisabledTypeSelect } from '@flex-private-packages/recruiting-common/components';
import { useState } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import type { JobDescriptionFormState } from '../models';

export function DisabledTypeField({ required }: { required: boolean }) {
  const { control, clearErrors } = useFormContext<JobDescriptionFormState>();
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState(false);

  return (
    <Controller
      key="handicapCase"
      control={control}
      name="handicapCase"
      rules={{
        required: required
          ? t(trans('recruiting.handicap.edit.helper.required'))
          : false,
      }}
      render={({
        field: { ref, onChange, value },
        fieldState: { invalid, error },
      }) => {
        const fieldValue = value ? t(DISABLED_TYPE_CONTENT[value].i18n) : '';

        return (
          <DisabledTypeSelect
            open={isOpen}
            onOpenChange={setIsOpen}
            value={value}
            onDisabledTypeChange={newValue => {
              onChange(newValue);
              clearErrors('handicapCase');
            }}
          >
            {/** onFocus재호출 방지 */}
            <div role="button">
              <TextField
                key={fieldValue}
                defaultValue={fieldValue}
                ref={ref}
                variant="solid"
                id="handicapCase"
                enterKeyHint="next"
                required={required}
                css={{ cursor: 'pointer' }}
                onFocus={() => {
                  setIsOpen(true);
                }}
                rightSlot={<ChevronDownMiniIcon style={{ marginRight: 12 }} />}
                label={
                  <TextField.Label leftSlot={<PersonTextRectangleIcon />}>
                    <Translation tKey={trans('recruiting.handicap')} />
                  </TextField.Label>
                }
                placeholder={t(trans('recruiting.handicap.edit.placeholder'))}
                state={invalid ? 'error' : 'default'}
                helperText={
                  <TextField.HelperText>{error?.message}</TextField.HelperText>
                }
              />
            </div>
          </DisabledTypeSelect>
        );
      }}
    />
  );
}
